module.exports = __webpack_public_path__ + "static/water-recreation-1af222ee0a8948d5e8d123f0e14d9a82.jpg";